<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
  Program: Login page
  Author: SDL
  Brief: User login page
-->
<template>
  <fragment>
    <!--
    <div class="ui--form-login login-info" v-if="errorState.code === 'authOk'">
      <header class="mb-4">
        <img :src="$CONTEXT + '/static/image/main/simbol.png'" class="mb-3 ui--brand-simbol" alt="System Simbol">
        <span class="brand-text">{{title}}</span>
      </header>
      <hr class="mb-4">
      <dl class="row">
        <dt class="col-6 text-right">Current Connection IP</dt>
        <dd class="col-6 text-left">168.219.213.224</dd>
        <dt class="col-6 text-right">Last Connection IP</dt>
        <dd class="col-6 text-left">168.219.213.224</dd>
        <dt class="col-6 text-right">Last Login Time</dt>
        <dd class="col-6 text-left">Wed Feb 12 15:24:41 KST 2014</dd>
      </dl>
      <button class="btn btn-lg btn-secondary" type="button" @click="gotoMain">{{title}} 바로가기</button>
    </div>
    -->
    <div class="loader" v-if="isLoaderVisible">
      <div class="sdl-center wd-3" style="width:610px;">
        <!-- message box -->
        <div class="msg-box">
          <div class="msg-icon"><em class="icon-info text-warning icon-size-2"></em></div>
          <div class="msg-text">
            <h3 class="mb-4">Information Message</h3>
            <strong class="d-block mb-3">{{ $t('sdl.common.message.initLoadingMsg') }}</strong>
            <ol class="list-unstyled">
              <li>{{ $t('sdl.common.message.browserInfo1') }}</li>
              <li>{{ $t('sdl.common.message.browserInfo2') }}</li>
              <li>{{ $t('sdl.common.message.browserInfo3') }}</li>
              <li>{{ $t('sdl.common.message.browserInfo4') }}</li>
            </ol>
          </div>
        </div>
        <!-- //message box -->
      </div>

      <footer class="ui--footer-container">
        <div class="ui--footer-in">
          <span>&copy; Samsung</span>
        </div>
      </footer>
    </div>

    <div style="width:100%" v-else-if="errorState.code !== '196'">
      <div v-if="lnbHideValue" >
        <form class="ui--form-login" @submit.prevent @keyup.enter="handleSubmit">
          <header class="mb-4">
            <img :src="$CONTEXT + '/static/image/main/simbol.png'" class="mb-3 ui--brand-simbol" alt="System Simbol" />
            <span class="brand-text">{{ title }}</span>
          </header>
          <label for="inputID" class="sr-only">ID</label>
          <input
            type="text"
            id="inputID"
            class="form-control ui--login-id"
            placeholder="ID"
            required
            autofocus
            v-model="userId"
          />
          <label for="inputPassword" class="sr-only" v-show="false"  >Password </label>
          <input
            type="password"
            id="inputPassword"
            class="form-control ui--login-pass"
            placeholder="Password"
            required
            v-model="password"
            style="display: none"
          />
          <div class="checkbox mb-3"  >
            <label><input type="checkbox" v-model="rememberMe" style="display: none" /> </label>
          </div>
          <button class="btn btn-lg btn-primary btn-block" type="button" @click="handleSubmit()">Login</button>
          <button class="btn btn-lg btn-outline-secondary btn-block" type="button" @click="loginByAd()">
            AD SSO Login
          </button>
          <button class="btn btn-lg btn-outline-secondary btn-block" type="button" @click="loginByNewEpTray()">
            New EpTray Login
          </button>
          <p class="mt-3">
            <router-link :to="$CONTEXT + '/register'">{{ $t('sdl.common.label.membership') }}</router-link
            >&nbsp;&nbsp;|&nbsp;&nbsp;<router-link :to="$CONTEXT + '/initPassword'">
              {{ $t('sdl.common.label.initPassword') }}
            </router-link>
          </p>
        </form>
      </div>
    </div>
    <div class="ui--form-login login-info" v-else>
      <header class="mb-4">
        <img :src="$CONTEXT + '/static/image/main/simbol.png'" class="mb-3 ui--brand-simbol" alt="System Simbol" />
        <span class="brand-text">{{ title }}</span>
      </header>
      <hr class="mb-4" />
      <div class="message">
        <p v-html="$t('sdl.common.label.selectRole')"></p>
        <div class="file-list bg-white mb-3">
          <ul>
            <li v-for="(role, index) in roleList" :key="index">
              <div class="form-check text-left">
                <label class="form-check-label"
                  ><input type="checkbox" class="form-check-input" v-model="role.selected" /> {{ role.roleName }}</label
                >
              </div>
            </li>
          </ul>
          <!-- // file-list -->
        </div>
      </div>
      <button class="btn btn-lg btn-primary" type="button" @click="signonReg">
        {{ $t('sdl.identity.label.userRegistration') }}
      </button>
    </div>
    <!-- Footer -->
    <div v-if="lnbHideValue" >
      <footer class="ui--footer-container" v-if="!isLoaderVisible">
        <p class="text-muted">
          {{ $t('sdl.common.message.onlyAuthUserLegalSanctions') }}
        </p>
        <span>&copy; Samsung</span>
      </footer>
    </div>
  </fragment>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';
import loginService from '@/service/loginService';

export default {
  name: 'LoginPage',
  data() {
    return {
      title: SDLUtil.getMsgProp('sdl.common.projectName'),
      userId: 'admin',
      password: '!QAZxsw23edc',
      rememberMe: false,
      submitted: false,
      roleList: [],
      isLoaderVisible: true,
      websocket: null,
      newEpTrayKey: null,
      lnbHideValue: false,
    };
  },
  methods: {
    ...mapActions(['login', 'logout', 'loginNewEpTray']),
    async handleSubmit() {
      // SDLUtil.alert({ msg: 'sdp.currency.exchRate.gdatu' });
      this.submitted = true;
      const { userId, password } = this;
      if (userId && password) {
        const loginResult = await this.login({ userId: this.userId, password: this.password });
        this.afterLoginProcess(loginResult);
      }
    },
    loginByAd() {
      const redirect = this.$route.query.redirect || '';
      if (redirect) {
        window.location.href = `${SDLUtil.API_URL}/noauth/saml-request?redirect=${redirect}`;
      } else {
        window.location.href = `${SDLUtil.API_URL}/noauth/saml-request`;
      }
    },
    async loginByNewEpTray() {
      let loginResult = false;
      SDLUtil.showLoadingBar(true);
      await this.socConnect().then((data) => {
        this.newEpTrayKey = data;
        this.websocket.close();
      }).catch((err) => {
        SDLUtil.alert(err);
      });
      SDLUtil.showLoadingBar(false);

      if (this.newEpTrayKey) {
        if (this.newEpTrayKey.result === 'success') {
          const { userInfo, key } = this.newEpTrayKey;
          loginResult = await this.loginNewEpTray({ userInfo, key });
        } else {
          SDLUtil.alert(`sdl.epTray.error.${this.newEpTrayKey.errorCode}`);
        }
      }

      if (!loginResult) {
        if (this.$route.query.token) {
          loginService.setToken(this.$route.query.token);
          document.location = `${SDLUtil.WEB_CONTEXT_PATH}/`;
        }
      }
      this.afterLoginProcess(loginResult);
    },
    afterLoginProcess(loginResult) {
      // console.log('LoginPage:', loginResult);
      if (loginResult) {
        // console.log('userInfo:', SDLUtil.getLoginedUserInfo());
        // this.$store.commit('ERROR_STATE', { code: 'authOk' });
        if (this.rememberMe) {
          localStorage.setItem('rememberMe', 'true');
          localStorage.setItem('rememberId', this.userId);
        } else {
          localStorage.removeItem('rememberMe');
          localStorage.removeItem('rememberId');
        }
        this.gotoMain();
      }
    },
    gotoMain() {
      // this.$router.push({
      //   path: '/',
      // });
      // Do not use the router, because you need to bring the menu dynamically, reload it again with a token
      const redirect = this.$route.query.redirect || '';
      if (redirect) {

        var redirectUrl = `${this.$context}/?redirect=${redirect}`;
        var redirectEncodeUri = `${this.$context}/?redirect=${encodeURIComponent(redirect)}`;

        console.log(redirectUrl);
        console.log(redirectEncodeUri);

        // window.location.href = `${this.$context}/?redirect=${redirect}`;
        window.location.href = redirectEncodeUri;
        
      } else {
        window.location.href = `${this.$context}/`;
      }
    },
    getRoleList() {
      axios
        .get(`${SDLUtil.API_URL}/auth/noauth/roles`)
        .then(({ data }) => {
          // console.log(data);
          this.roleList = data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    signonReg() {
      const chkRoleList = [];
      this.roleList.forEach(role => {
        if (role.selected) chkRoleList.push(role.roleName);
      });
      if (chkRoleList.length === 0) {
        SDLUtil.alert('sdl.common.message.checkRoleUser');
        return;
      }
      axios
        .post(
          `${SDLUtil.API_URL}/auth/noauth/user-reg-integration?roleList=${encodeURIComponent(
            chkRoleList.join(','),
          )}&jwtData=${encodeURIComponent(this.errorState.message)}`,
        )
        // eslint-disable-next-line no-unused-vars
        .then(({ response }) => {
          this.$store.commit('ERROR_STATE', {
            code: '191',
            reason: SDLUtil.getMsgProp('sdl.auth.message.user.waiting'),
          });
        })
        .catch(err => {
          console.error(err);
          SDLUtil.errorAlert(err);
        });
    },
    socConnect() {
      return new Promise(((resolve, reject) => {
        const server = new WebSocket('wss://localhost:29283');
        this.websocket = server;
        server.onopen = () => {
          server.send('{"rqtype":"getknoxsso","token":"","data":"KCC60TRAY0072"}');
          server.onmessage = (event) => {
            const socketData = JSON.parse(event.data);
            if (socketData.rpcode === 'RETURN_SUCCESS') {
              resolve(JSON.parse(socketData.data));
            } else {
              this.websocket.close();
              let err;
              if (socketData.rpcode === 'EMPTY_BOX') err = 'sdl.epTray.rpCode.EMPTY_BOX';
              else err = `sdl.epTray.rpCode.${socketData.detail}`;
              reject(err);
            }
          };
        };
        server.onerror = () => {
          const err = 'sdl.epTray.rpCode.CONNECTION_FAILED';
          reject(err);
        };
      }));
    },
  },
  watch: {
    errorState() {
      if (this.errorState.code === '196') {
        this.isLoaderVisible = false;
        this.getRoleList();
        // } else if (this.errorState.code === '191') {
        //   SDLUtil.alert(this.errorState.reason);
      } else if (this.errorState.code !== 'authOk') {
        if (this.errorState.code === '185' || this.errorState.code === '190') {
          this.isLoaderVisible = false;
          SDLUtil.alert(this.errorState.reason);
        } else {
          document.location = `${SDLUtil.WEB_CONTEXT_PATH}/error?code=${this.errorState.code}`;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      errorState: 'getErrorState',
    }),
  },
  created() {
    document.querySelector('body').classList.remove('register-wrap');
    document.querySelector('body').classList.add('ui--login-wrap');
    // this.logout();
    const rememberMe = localStorage.getItem('rememberMe');
    if (rememberMe === 'true') {
      this.rememberMe = true;
      this.userId = localStorage.getItem('rememberId');
    }

    // for AdLogin RegistrationException
    if (this.$route.query.code) {
      this.$store.commit('ERROR_STATE', {
        code: this.$route.query.code,
        message: this.$route.query.message,
      });
    }
    try {
      const { redirect } = this.$route.query;
      let getUserID = new URLSearchParams(redirect.split('?')[1]).get('e').replace(/ /gi, '+');
      if (!getUserID) {
        const redirectParam = decodeURIComponent(decodeURIComponent(redirect));
        getUserID = new URLSearchParams(redirectParam.split('?')[2]).get('e').replace(/ /gi, '+');
      }
      if (getUserID !== '') {
        const formData = new FormData();
        formData.append('userId', getUserID);
        axios
          .post(
            `${SDLUtil.API_URL}/noauth/login/decodeUserid`,
            formData,
          )
          .then(
            (resonse) => {
              this.userId = resonse.data.uid;
              this.password = '!QAZxsw23edc';
              localStorage.setItem('encodeUserID', getUserID);
              this.handleSubmit();
            },
          );
      }
    } catch (e) {
      this.userId = this.$route.query.userId;
      this.password = '!QAZxsw23edc';
      this.lnbHideValue = true;
    }
    // if (this.userId) {
    //   this.handleSubmit();
    // } else {
    //   this.lnbHideValue = true;
    // }
  },
  mounted() {
    if (SDLUtil.isLogin()) {
      this.gotoMain();
    } else if (this.$route.query.token) {
      loginService.setToken(this.$route.query.token);
      this.gotoMain();
    } else {
      this.isLoaderVisible = false;
    }

    if (this.$route.params.userId) {
      // Automatically enter the ID you entered when you passed the membership registration
      this.password = '';
      this.userId = this.$route.params.userId;
    }
  },
};
</script>
<style>
.loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/LoginPage.vue